import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import posthog from "posthog-js";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

if (environment.postHog.enabled) {
  posthog.init(environment.postHog.postHogKey, {
    api_host: environment.postHog.postHogHost,
    // Somente eventos explícitos: autocapture/replay estouram a cota gratuita
    // (ver incidente de quota de replay em 2026) e pesam no browser do usuário.
    autocapture: false,
    disable_session_recording: true,
    person_profiles: "identified_only",
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

document.documentElement.setAttribute(
  "legacy-layout",
  environment.legacyLayout.toString()
);
